module.exports = __webpack_public_path__ + "static/media/hmdevcoders.2a9f0436.png";